var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-list", {
    attrs: {
      entity: "encounter",
      "api-name": "encounters",
      "use-events": true,
      "entity-sort": _vm.encounterSort,
      "new-route-name": "newEncounter",
      "event-id": _vm.eventId,
      "team-id": _vm.teamId,
      isArchive: "",
      "hide-status": "",
      entityHeaders: _vm.headers
    },
    scopedSlots: _vm._u(
      [
        {
          key: `item.day`,
          fn: function({ item }) {
            return [
              _vm._v(" " + _vm._s(_vm.getEncounterDayAndTime(item)) + " ")
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }